<template>
  <AppLayout>
    <template #subheader>
      <button class="btn btn-sm btn-outline-secondary d-lg-none mb-2" type="button" @click="isFilterOpen = true">
        Filtry
      </button>
      <div v-if="isFilterOpen" class="offcanvas-backdrop fade show" @click="isFilterOpen = false">
      </div>
      <div class="mobile-filter-panel" :class="{ show: isFilterOpen }">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="mb-0">Filtry</h5>
          <button class="btn-close" @click="isFilterOpen = false">
          </button>
        </div>
        <div class="d-flex flex-column gap-3">
          <div>
            <label class="mb-1">Projekt:</label>
            <select class="form-select form-select-sm" v-model="selectedProjectId" @change="updateSelectedProject">
              <option value="0">Wszystkie projekty</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ truncateLabel(project.label) }}
              </option>
            </select>
          </div>
          <div>
            <label class="mb-1">Zespół:</label>
            <select class="form-select form-select-sm" v-model="selectedTeamName" @change="updateSelectedTeam"
              :disabled="!selectedProjectId || (teams && teams.length === 0)">
              <option value="">Wszystkie</option>
              <option v-for="team in teams" :key="team.name" :value="team.name">
                {{ team.name }}
              </option>
            </select>
          </div>
          <Link v-if="selectedProjectId" :href="route('projects.show.numbering', { project: selectedProjectId })"
            class="btn btn-sm btn-outline-primary">
          Edytuj zespoły
          </Link>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" v-model="archivedShown" @change="changeShowArchived()">
            <label class="form-check-label">
              Pokaż zarchiwizowane
            </label>
          </div>
          <button v-if="selectedRecord?.id" class="btn btn-sm btn-outline-primary" @click="clickShowHistoryModal">
            Pokaż historię
          </button>
        </div>
      </div>
      <div class="d-none d-lg-flex align-items-start justify-content-between flex-nowrap gap-3">
        <div class="d-flex align-items-center gap-3 flex-nowrap">
          <div class="d-flex align-items-center gap-2">
            <label class="mb-0">Projekt:</label>
            <select class="form-select form-select-sm" v-model="selectedProjectId" @change="updateSelectedProject"
              style="min-width: 260px; max-width: 500px;">
              <option value="0">Wszystkie</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ truncateLabel(project.label) }}
              </option>
            </select>
          </div>
          <div class="d-flex align-items-center gap-2">
            <label class="mb-0">Zespół:</label>
            <select class="form-select form-select-sm" v-model="selectedTeamName" @change="updateSelectedTeam"
              :disabled="!selectedProjectId || (teams && teams.length === 0)" style="width: 180px;">
              <option value="">Wszystkie</option>
              <option v-for="team in teams" :key="team.name" :value="team.name">
                {{ team.name }}
              </option>
            </select>
          </div>
          <Link v-if="selectedProjectId" :href="route('projects.show.numbering', { project: selectedProjectId })"
            class="btn btn-xs btn-outline-primary">
          Edytuj zespoły
          </Link>
        </div>
        <div class="d-flex align-items-center gap-3 flex-nowrap">
          <button v-if="selectedRecord?.id" class="btn btn-sm btn-outline-primary" @click="clickShowHistoryModal"
            style="white-space: nowrap;">
            Pokaż historię
          </button>
          <ShowHistoryModal :record-id="selectedRecord?.id" :projects="projects" :teams="teams" :units="units"
            :suppliers="suppliers" :statuses="statuses" :categories="categories" :producers="producers"
            :warehouses="warehouses" ref="showHistoryModalRef" />
        </div>
      </div>
    </template>

    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading d-block">
          <div v-if="$page.props.flash && $page.props.flash.error"
            class="alert alert-danger d-flex align-items-center gap-2 mb-3" role="alert">
            <i class="bi bi-exclamation-triangle-fill"></i>
            <span>{{ $page.props.flash.error }}</span>
          </div>
          <div v-if="$page.props.flash && $page.props.flash.success"
            class="alert alert-success d-flex align-items-center gap-2 mb-3" role="alert">
            <i class="bi bi-check-circle-fill"></i>
            <span>{{ $page.props.flash.success }}</span>
          </div>
        </div>

        <div class="widget-content">
          <div>
            <div class="d-flex align-items-center mb-2">
              <div class="input-group input-group-sm" style="width: 180px;">
                <span class="input-group-text">Idź do strony:</span>
                <input v-model.number="goToPageNumber" type="number" min="1" class="form-control" placeholder="Strona"
                  @keyup.enter="$refs.requiredProjectItemsGrid.goToPage(goToPageNumber)">
              </div>

              <button v-if="hasPermission('canEditRequiredProjectItems')" type="button" class="btn btn-info btn-sm"
                style="height: 31px; margin-left: 6px;" @click="openOrderWizard">
                Kreator zamówienia stali
              </button>
              <button v-if="hasPermission('canEditRequiredProjectItems')" type="button" class="btn btn-primary btn-sm"
                style="height: 31px; margin-left: 6px;" @click="openListWizard">
                Lista zamówień stali
              </button>
            </div>
            <ejs-grid ref="requiredProjectItemsGrid" id="requiredProjectItemsGrid"
              :height="selectedRecord?.id ? '40vh' : gridHeight" :dataSource="requiredProjectItemsDataManager"
              :allowTextWrap='false' :allowExcelExport='true' :allowPaging="true" :allowSorting='true'
              :allowFiltering='true' :allowReordering='true' :allowResizing='true' :showColumnChooser='true'
              :allowSelection='true' :enablePersistence='true' :pageSettings="pageSettings" :editSettings="editSettings"
              :filterSettings="filterOptions" :toolbar="toolbar" :rowSelecting="rowSelecting"
              :contextMenuItems="contextMenuItems" :selectionSettings="selectionOptions"
              :headerCellInfo="headerCellInfoEvent" :toolbarClick="clickToolbarHandler"
              :contextMenuOpen="onContextMenuOpen" :contextMenuClick="clickContextMenuHandler"
              :actionBegin="actionBeginHandler" :actionComplete="actionCompleteHandler" :dataBound="dataBoundHandler"
              @queryCellInfo="queryCellInfo" @recordClick="onRecordClick" @cellEdit="onCellEdit" :keyPressed="onKeyDown"
              :excelQueryCellInfo="excelQueryCellInfo" :query="gridQuery">

              <e-columns>
                <e-column type="number" width="70" :template="'indexTemplate'" :allowEditing="false"
                  :allowSorting="false" :allowFiltering="false" headerTooltip="L.p." headerText="L.p." />
                <e-column type="checkbox" width="35" headerTooltip="Zaznacz" />

                <e-column field="id" :isPrimaryKey="true" headerText="Nr poz." headerTooltip="Nr Poz." width="125"
                  :allowEditing="false" :allowSorting="true" :template="'idWithReplacementTemplate'" />
                <e-column field="was_edited_later" width="35" headerTooltip="Wartość została zmieniona!" headerText="!"
                  :allowEditing="true" :allowFiltering="false" type="number" :edit="wasEditedLaterEdit"
                  :template="'wasEditedLaterTemplate'" editType="dropdownedit" textAlign="Center"
                  :allowSorting="false" />
                <e-column field="project.number" headerTooltip="Projekt" headerText="Project" :allowEditing="false"
                  :filter="filterDefault" />
                <e-column field="team_name" headerTooltip="Zespół" headerText="Zespół" :allowEditing="false"
                  :filter="filterDefault" />
                <e-column field="subteam_drawing_no" headerTooltip="Podzespół nr rysunku"
                  headerText="Podzespół nr rysunku" :allowEditing="true" :filter="filterDefault" />
                <e-column field="quote_request_numbers" headerTooltip="Numer Zapytań ofertowych"
                  headerText="Nr Zap. ofert." :allowEditing="false" :filter="filterDefault"
                  :template="'quoteRequestsTemplate'" type="string" :allowSorting="false" />
                <e-column field="order_list_numbers" headerTooltip="Numer zamówienia" headerText="Nr zamówienia"
                  type="string" :allowEditing="false" :allowSorting="false" :allowFiltering="true"
                  :filter="filterDefault" :template="'orderListTemplate'" />
                <e-column field="article.id" headerText="Id artykułu" headerTooltip="Id artykułu" :allowEditing="false"
                  :template="'artIdTpl'" />
                <e-column field="article.catalog_number" headerText="Nr katalogowy" headerTooltip="Nr katalogowy"
                  :allowEditing="false" :template="'artCatalogTpl'" />
                <e-column field="article.model" headerText="Model" headerTooltip="Model" :allowEditing="false"
                  :template="'artModelTpl'" />
                <e-column field="article.description" headerText="Nazwa/Opis" width="200" headerTooltip="Nazwa/Opis"
                  :allowEditing="false" :template="'artDescTpl'" />
                <e-column field="article.article_unit.name" headerText="J.m." width="105" headerTooltip="J.m."
                  :allowEditing="false" :template="'artUnitTpl'" />


                <e-column field="article.producer.id" headerText="Producent" headerTooltip="Producent"
                  foreignKeyValue="name" foreignKeyField="id" :dataSource="producers" :allowEditing="false"
                  :allowSorting="true" :allowFiltering="true" :filter="filterProducers" :template="'artProducerTpl'" />
                <e-column field="article.customer_category.id" headerText="Kategoria" width="250"
                  editType="dropdownedit" :dataSource="categories" foreignKeyValue='name' foreignKeyField='id'
                  :filter='filterCategories'></e-column>
                <e-column field="quantity_required" headerTooltip="Ilość wymagana" headerText="Ilość wymagana"
                  format="N2" type="number" :edit="editNumbersPlusParams" editType="numericedit" :allowEditing="true"
                  textAlign="Right" />

                <e-column field="numbering.quantity" headerTooltip="Ilość maszyn" headerText="Ilość maszyn"
                  :allowEditing="false" type="number" :filter="filterNumeric" textAlign="Right" />
                <e-column field="quantity_to_order" headerText="Ilość do zam." :allowEditing="false" type="number"
                  format="N2" :filter="filterNumeric" textAlign="Right" />
                <e-column v-if="hasPermission('canViewArticlesPricesAndHistory')" field="article.price_netto"
                  headerText="Cena netto" type="number" :filter="filterNumeric" editType="numericedit" format="N2"
                  textAlign="Right" headerTooltip="Cena netto" :allowEditing="false" />

                <e-column v-if="hasPermission('canViewArticlesPricesAndHistory')" field="value_netto"
                  headerText="Wartość netto" headerTooltip="Ilość do zam. × Cena netto" width="130" type="number"
                  format="N2" textAlign="Right" :allowEditing="false" :allowSorting="true" :allowFiltering="false"
                  :valueAccessor="valueNettoAccessor" />
                <e-column v-if="hasPermission('canViewArticlesPricesAndHistory')" field="article.currency.name"
                  headerText="Waluta" :allowEditing="false" :allowSearching="false" :filter="filterDefault"
                  textAlign="Right" headerTextAlign="Left"></e-column>
                <e-column field="article_main_warehouse.quantity" headerTooltip="Ilość magazynowa"
                  headerText="Ilość magazynowa" format="N2" type="number" :allowEditing="false" textAlign="Right" />


                <e-column field="status" headerTooltip="Status" headerText="Status" :allowEditing="true"
                  editType="dropdownedit" :edit="requiredProjectItemsStatusesParams" />
                <e-column field="delivered_quantity" headerText="Ilość dostarczona" type="number" format="N2"
                  :allowEditing="false" textAlign="Right" />

                <e-column field="release_date" headerTooltip="Data zwolnienia" headerText="Data zwolnienia"
                  :allowEditing="true" type="date" format="dd.MM.yyyy" editType="datepickeredit" />
                <e-column field="release_by.name" headerText="Zwolnione przez" :allowEditing="false"
                  :filter="filterDefault" headerTextAlign="Left" />
                <e-column field="inventory_status_name" headerTooltip="Status Mag." headerText="Status Mag."
                  :filter="filterStatusMag" :allowEditing="false" editType="dropdownedit" type="string"
                  :edit="inventoryStatusesParams" :template="'statusColorsTemplate'" />
                <e-column field="comments" headerTooltip="Uwagi" headerText="Uwagi" :allowEditing="true"
                  type="string" />

                <e-column field="suppliers_short_names" headerTooltip="Dostawcy" headerText="Dostawcy"
                  :allowEditing="true" editType="string" :filter='filterSuppliers' :edit="suppliersParams" />
                <e-column field="created_by.name" headerTooltip="Dodany przez" headerText="Dodany przez"
                  :allowEditing="false" />
                <e-column field="created_at" headerTooltip="Data dodania" headerText="Data dodania"
                  :allowEditing="false" type="date" :filter="rangeDateFilter" format="dd.MM.yyyy H:mm:ss" />
                <e-column field="delivery_date" headerTooltip="Data dostawy" headerText="Data dostawy"
                  :allowEditing="true" type="date" format="dd.MM.yyyy" editType="datepickeredit" />
                <e-column field="order_submission_date" headerTooltip="Data Zlec. Zam." headerText="Data Zlec. Zam."
                  :allowEditing="true" type="date" format="dd.MM.yyyy" editType="datepickeredit" />
                <e-column field="order_status_confirmation_date" headerTooltip="Data Wydr. Zam."
                  headerText="Data Wydr. Zam." :allowEditing="true" type="date" format="dd.MM.yyyy"
                  editType="datepickeredit" />
                <e-column field="numbering.production_date" headerTooltip="Data Prod." headerText="Data Prod."
                  :allowEditing="false" type="date" format="dd.MM.yyyy" />
                <e-column field="lead_time" headerTooltip="Czas dostawy" headerText="Czas dostawy" :allowEditing="true"
                  type="date" format="dd.MM.yyyy" />
                <e-column field="updated_by.name" headerTooltip="Ostatnio zmienił" headerText="Ostatnio zmienił"
                  :allowEditing="false" :allowSorting="false" :allowFitering="false" type="string" />
                <e-column field="updated_at" headerTooltip="Ostatnia zmiana" headerText="Ostatnia zmiana"
                  :allowEditing="false" :allowSorting="false" :allowFitering="false" type="date" format="dd.MM.yyyy" />
                <e-column field="warehouse_received" headerTooltip="Magazyn" headerText="Magazyn"
                  :filter="filterDefault" type="string" />
                <e-column field="dw_numbers" type="string" headerTooltip="DW" headerText="DW" :template="'dwTemplate'"
                  :allowEditing="false" :allowSorting="true" :allowFiltering="true" :filter="filterDefault" />
                <e-column field="patent_number" headerTooltip="Nr Patentu" headerText="Nr Patentu" :allowEditing="true"
                  type="string" :visible="false" :allowFiltering="false" :allowSorting='false' />
                <e-column field="deliveryDeadlineExceeded" headerTooltip="Przekr. term. dost." type="string"
                  headerText="Przekr. term. dost." :template="'deliveryDeadlineExceeded'" :allowEditing="false"
                  :filter="filterDefault" />

                <e-column field="barcode" headerTooltip="Kody kreskowe" headerText="Kody kreskowe" type="string"
                  :allowEditing="true" :visible="false" :allowFiltering="false" :allowSorting='false' />

                <e-column field="article.link" headerText="Link" :allowEditing="false" :template="'artLinkTpl'"
                  type="string" />

                <e-column field="article.files" headerText="Załączniki art." width="200" :allowSearching="false"
                  :template="'attachmentsTemplate'" :allowEditing="false" :allowFiltering="false"
                  :allowSorting='false' />
                <e-column field="files" headerText="Załączniki Zapotrz." width="200" :allowSearching="false"
                  :template="'attachmentsRequiredTemplate'" :allowEditing="false" :allowFiltering="false"
                  :allowSorting='false' />
              </e-columns>

              <template v-slot:indexTemplate="{ data }">
                <span style="color:#a6a6a6">
                  {{ getRowIndex(data) }}
                </span>
              </template>
              <!-- ID wiersza + info o zamienniku -->
              <template v-slot:idWithReplacementTemplate="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">{{ data.id }}</div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    <strong>
                      {{ data.replacement?.replacement_created_by?.first_name }}
                      {{ data.replacement?.replacement_created_by?.last_name }}
                    </strong>
                    zaproponował zamiennik
                  </div>
                </div>
              </template>

              <!-- Artykuł: ID -->
              <template v-slot:artIdTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">{{ data.article?.id ?? '' }}</div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    {{ data.replacement?.article?.id ?? '' }}
                  </div>
                </div>
              </template>

              <!-- Nr katalogowy -->
              <template v-slot:artCatalogTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">{{ data.article?.catalog_number ?? '' }}</div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    {{ data.replacement?.article?.catalog_number ?? '' }}
                  </div>
                </div>
              </template>

              <!-- Model -->
              <template v-slot:artModelTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">{{ data.article?.model ?? '' }}</div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    {{ data.replacement?.article?.model ?? '' }}
                  </div>
                </div>
              </template>

              <!-- Nazwa/Opis -->
              <template v-slot:artDescTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main text-truncate">{{ data.article?.description ?? '' }}</div>
                  <div v-if="hasReplacement(data)" class="cell-replacement text-truncate">
                    {{ data.replacement?.article?.description ?? '' }}
                  </div>
                </div>
              </template>

              <!-- Link -->
              <template v-slot:artLinkTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">
                    <a v-if="data.article?.link" class="link link-primary" target="_blank" rel="noopener"
                      :href="data.article.link">{{ data.article.link }}</a>
                  </div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    <a v-if="data.replacement?.article?.link" class="link" target="_blank" rel="noopener"
                      :href="data.replacement.article.link">{{
                        data.replacement.article.link }}</a>
                  </div>
                </div>
              </template>

              <!-- J.m. -->
              <template v-slot:artUnitTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">{{ data.article?.article_unit?.name ?? '' }}</div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    {{ data.replacement?.article?.article_unit?.name ?? '' }}
                  </div>
                </div>
              </template>

              <!-- Producent -->
              <template v-slot:artProducerTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">
                    {{ resolveProducerName(data.article?.producer?.id ?? data.article?.producer_id)
                    }}
                  </div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    {{
                      resolveProducerName(data.replacement?.article?.producer?.id ??
                        data.replacement?.article?.producer_id)
                    }}
                  </div>
                </div>
              </template>

              <!-- Kategoria -->
              <template v-slot:artCategoryTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">
                    {{ resolveCategoryName(data.article?.customer_category?.id ??
                      data.article?.customer_category_id) }}
                  </div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    {{
                      resolveCategoryName(data.replacement?.article?.customer_category?.id ??
                        data.replacement?.article?.customer_category_id)
                    }}
                  </div>
                </div>
              </template>

              <!-- ruchy magazynowe -->
              <template v-slot:dwTemplate="{ data }">
                <div v-for="(dw, idx) in data.dw_warehouse_movements">
                  <template v-if="generatingPDF">
                    <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-danger"
                      style="width:20px; height:20px">
                    </div>
                  </template>
                  <template v-else>
                    <span @click="showDWPDF(dw.id, data.project?.number, data.team_name)"
                      class="text-primary cursor-pointer">
                      <i class="bi bi-search"></i> {{ dw.document_number }} - {{ dw.quantity }} {{
                        data.article?.article_unit?.name ?? '' }}
                    </span>
                  </template>
                  <template v-if="idx + 1 < data.dw_warehouse_movements.length">,</template>
                </div>
              </template>

              <!-- wykrzyknik -->
              <template v-slot:wasEditedLaterTemplate="{ data }">
                <span v-if="data.was_edited_later"
                  style="color: white; background-color: orangered; font-size:16px; font-weight: 700; width: 20px; display: block; text-align: center">
                  !
                </span>
              </template>

              <template v-slot:quoteRequestsTemplate="{ data }">
                <span v-for="(quoteRequest, idx) in data.quote_request_items">
                  {{ quoteRequest.quote_request_number }}<span v-if="idx < data.quote_request_items.length - 1">,
                  </span>
                </span>
              </template>

              <template v-slot:orderListTemplate="{ data }">
                <span v-for="(orderList, idx) in data.order_lists">
                  {{ orderList.order_number }}<span v-if="idx < data.order_lists.length - 1">, </span>
                </span>
              </template>

              <template v-slot:linkTemplate="{ data }">
                <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.article?.link>
                  {{ data.article?.link }}</a>
              </template>

              <template v-slot:deliveryDeadlineExceeded="{ data }">
                <template v-if="data.numbering?.team_name_construction === data.team_name">
                  <template v-if="compareDeliveryDeadlineDates(data.numbering?.production_date, data.delivery_date)">
                    <div class="alert-danger p-2">
                      Przekroczony o
                      {{ compareDeliveryDeadlineDates(data.numbering?.production_date,
                        data.delivery_date) }} dni!
                    </div>
                  </template>
                </template>
              </template>
              <template v-slot:statusColorsTemplate="{ data }">
                <div class="status-cell">

                  <span v-if="data.inventory_status?.bg_color" class="status-color"
                    :style="{ backgroundColor: data.inventory_status?.bg_color }"
                    :title="data.inventory_status?.name"></span>


                  <span class="status-text">{{ data.inventory_status?.name || '' }}</span>
                </div>
              </template>
              <template v-slot:attachmentsTemplate="{ data }">
                <div>
                  <a v-if="data.article.files && data.article.files.length" class="text-primary"
                    :href="route('articles.files.show', { file: data.article.files[0].id })" target="_blank">
                    {{ data.article.files[0].original_name }}
                  </a>

                  <button class="ms-1 btn btn-xs btn-outline-default" @click="showAttachmentsModal(data.article)">+{{
                    Object.keys(data.article.files).length || ''
                  }}
                  </button>
                </div>
              </template>
              <template v-slot:attachmentsRequiredTemplate="{ data }">
                <div>
                  <a v-if="data.files && data.files.length" class="text-primary"
                    :href="route('requiredProjectItem.files.show', { file: data.files[0].id })" target="_blank">
                    {{ data.files[0].original_name }}
                  </a>

                  <button class="ms-1 btn btn-xs btn-outline-default" @click="showRequiredAttachmentsModal(data)">+{{
                    Object.keys(data.files).length || ''
                  }}
                  </button>
                </div>
              </template>

            </ejs-grid>
          </div>

        </div>
      </div>
    </div>

    <AddRequiredProjectItemsModal v-if="showAddRequiredProjectItemsModal" :project="selectedProjectId"
      :team="selectedTeamName" :liczba_maszyn="liczba_maszyn" :articlesToClone="articlesToClone" :currencys="currencys"
      ref="addRequiredProjectItemsModalRef" :suppliers="suppliers" :producers="producers" :units="units"
      :categories="categories" @added-article="this.$refs.requiredProjectItemsGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection" />

    <EditArticleModal v-if="showEditModal" :article="selectedRecordToEdit"
      @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" ref="editArticleModalRef" :units="units"
      :categories="categories" :producers="producers" :currencys="currencys" :warehouses="warehouses"
      :exchangeRates="exchangeRates" @update-success="successMsg" @clear-selection="clearSelection"
      @update-error="errorMsg" />

    <AddToQuoteRequestModal v-if="showAddToQuoteRequestModal" :project="selectedProjectId"
      :selectedItems="selectedRecords" :units="units" ref="addQuoteRequestModalRef"
      @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" @clear-selection="clearSelection" />

    <AddOrderModal v-if="showAddOrderModal" ref="addOrderModalRef" :project="selectedProjectId" :team="selectedTeamName"
      context="from_required_project" :selectedItems="selectedRecords" :order_where_list="order_where_list"
      :currencys="currencys" :negotiations="negotiations" @added-success="successMsg" @added-error="errorMsg"
      @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" @clear-selection="clearSelection" />

    <AddToOrderModal v-if="showAddToOrderModal" ref="addToOrderModalRef" :selectedItems="selectedRecords"
      :order_list="order_list" context="from_required_project" :currencys="currencys" @added-success="successMsg"
      @added-error="errorMsg" @updated-article="this.$refs.requiredProjectItemsGrid.refresh()"
      @clear-selection="clearSelection" />

    <CloneRequestProjectItemModal v-if="showCloneRequestProjectItemModal" :selectedProject="selectedProjectId"
      :selectedTeam="selectedTeamName" :selectedRecords="selectedRecords" ref="cloneRequestProjectItemModalRef"
      :teams="teams" :projects="projects" :producers="producers" :categories="categories" :location="warehouses"
      :suppliers="suppliers" @updated-article="this.$refs.requiredProjectItemsGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection" />

    <ReplacementArticleModal v-if="showReplacementArticleModal" :selectedRecord="selectedRecord"
      ref="replacementArticleModalRef" :units="units" :categories="categories" :producers="producers"
      :locations="warehouses" @updated-article="this.$refs.requiredProjectItemsGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection" />

    <ChangeStatusModal v-if="showChangeStatusModal" :selectedRecords="selectedRecords" ref="changeStatusModalRef"
      :statuses="statuses" @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" @clear-selection="clearSelection" />

    <ChangeStatusMagModal v-if="showChangeStatusMagModal" :selectedRecords="selectedRecords"
      ref="changeStatusMagModalRef" :statuses="inventory_statuses"
      @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" @clear-selection="clearSelection" />

    <ChangeDeliveryDateModal v-if="showChangeDeliveryDateModal" :selectedRecords="selectedRecords"
      ref="changeDeliveryDateModalRef" @updated-article="this.$refs.requiredProjectItemsGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection" />

    <ChangeReleaseDateModal v-if="showChangeReleaseDateModal" :selectedRecords="selectedRecords"
      ref="changeReleaseDateModalRef" @updated-article="this.$refs.requiredProjectItemsGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection" />

    <ChangeOrderSubmissionDateModal v-if="showChangeOrderSubmissionDateModal" :selectedRecords="selectedRecords"
      ref="changeOrderSubmissionDateModalRef" @updated-article="this.$refs.requiredProjectItemsGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection" />

    <ChangeOrderStatusConfirmationDateModal v-if="showChangeOrderStatusConfirmationDateModal"
      :selectedRecords="selectedRecords" ref="changeOrderStatusConfirmationDateModalRef"
      @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" @clear-selection="clearSelection" />

    <DispositionDWModal v-if="showDispositionDWModall" :selectedRecords="selectedRecords"
      :projectID="this.selectedProjectId" ref="dispositionDWModalRef"
      @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" @clear-selection="clearSelection" />

    <ChangeMagazynModal v-if="showChangeMagazynModal" :selectedRecords="selectedRecords" ref="changeMagazynModalRef"
      @updated-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg"
      @added-error="errorMsg" @clear-selection="clearSelection" />

    <ArticleFilesModal v-if="showFilesModal" :article="selectedArticle" @close="showFilesModal = false"
      @refresh="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg" @added-error="errorMsg" />

    <RequiredProjectItemsFilesModal v-if="showRequiredFilesModal" :requiredProjectItem="selectedArticle"
      @close="showRequiredFilesModal = false" @refresh="this.$refs.requiredProjectItemsGrid.refresh()"
      @added-success="successMsg" @added-error="errorMsg" />

    <ShowDetails v-if="selectedRecord" :selectedRecord="selectedRecord" ref="showDetailsRef"></ShowDetails>

    <DraftDispositionsModal v-if="showDraftDispositionsModal" ref="draftDispositionsModalRef" />

    <OrderCreatorModal v-if="showOrderCreatorModal" :project="selectedProjectId" :team="selectedTeamName"
      :liczba_maszyn="liczba_maszyn" :kreator_kategorie="kreator_kategorie" ref="OrderCreatorModalRef"
      @added-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg" @added-error="errorMsg"
      @close="showOrderCreatorModal = false" />

    <CreatorListModal v-if="showCreatorListModal" :project="selectedProjectId" :team="selectedTeamName"
      :liczba_maszyn="liczba_maszyn" :kreator_kategorie="kreator_kategorie" ref="CreatorListModalRef"
      @added-article="this.$refs.requiredProjectItemsGrid.refresh()" @added-success="successMsg" @added-error="errorMsg"
      @close="showCreatorListModal = false" />
  </AppLayout>
</template>

<script>
import AppLayout from "../../Layouts/App.vue";
import { usePage } from "@inertiajs/vue3";
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';

MultiSelect.Inject(CheckBoxSelection);
import { Tooltip } from "@syncfusion/ej2-popups";
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter, ForeignKey,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  RowDD,
  VirtualScroll
} from '@syncfusion/ej2-vue-grids';
import { createElement } from "@syncfusion/ej2-base";
import { DataManager, Predicate, Query, WebMethodAdaptor } from '@syncfusion/ej2-data';
import { DateRangePicker } from "@syncfusion/ej2-calendars";
import { DropDownList } from "@syncfusion/ej2-dropdowns";
import moment from "moment";
import EditArticleModal from "./EditArticleModal.vue";
import { ref } from "vue";
import AddToQuoteRequestModal from "./AddToQuoteRequestModal.vue";
import OrderCreatorModal from "./OrderCreatorModal.vue";
import CreatorListModal from "./CreatorListModal.vue";
import AddRequiredProjectItemsModal from "./AddRequiredProjectItemsModal.vue";
import CloneRequestProjectItemModal from "./CloneRequestProjectItemModal.vue";
import ChangeStatusModal from "./ChangeStatusModal.vue";
import ChangeStatusMagModal from "./ChangeStatusMagModal.vue";
import ChangeDeliveryDateModal from "./ChangeDeliveryDateModal.vue";
import ChangeReleaseDateModal from "./ChangeReleaseDateModal.vue";
import ChangeOrderSubmissionDateModal from "./ChangeOrderSubmissionDateModal.vue";
import ChangeOrderStatusConfirmationDateModal from "./ChangeOrderStatusConfirmationDateModal.vue";
import DispositionDWModal from "./DispositionDWModal.vue";
import ShowDetails from "./ShowDetails.vue";
import ShowHistoryModal from "./ShowHistoryModal.vue";
import MoveItemToWarehouseModal from "../OrderLists/MoveItemToWarehouseModal.vue";
import ChangeMagazynModal from "./ChangeMagazynModal.vue";
import AddOrderModal from "../QuoteRequests/AddOrderModal.vue";
import AddToOrderModal from "../QuoteRequests/AddToOrderModal.vue";
import ArticleFilesModal from "../Warehouses/Articles/ArticleFilesModal.vue";
import RequiredProjectItemsFilesModal from "./RequiredProjectItemsFilesModal.vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import ReplacementArticleModal from "./ReplacementArticleModal.vue";
import DraftDispositionsModal from "./DraftDispositionsModal.vue";

const { hasRole, hasPermission } = usePermission();

let dropInstanceFilterUnits, dropInstanceFilterSuppliers, statusElem, statusObj, statusFilter, delivererElem,
  multiSelectObj;
export default {

  components: {
    ReplacementArticleModal,
    RequiredProjectItemsFilesModal,
    ArticleFilesModal,
    AddOrderModal,
    AddToOrderModal,
    ShowHistoryModal,
    MoveItemToWarehouseModal,
    ChangeStatusMagModal,
    ChangeDeliveryDateModal,
    ChangeReleaseDateModal,
    ChangeOrderSubmissionDateModal,
    CloneRequestProjectItemModal,
    ChangeOrderStatusConfirmationDateModal,
    DispositionDWModal,
    ShowDetails,
    ChangeStatusModal,
    AddRequiredProjectItemsModal,
    AddToQuoteRequestModal,
    OrderCreatorModal,
    CreatorListModal,
    EditArticleModal,
    ChangeMagazynModal,
    DraftDispositionsModal,
    AppLayout,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },

  provide: {
    grid: [DateRangePicker, Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, RowDD, VirtualScroll]
  },

  props: {
    projects: Object,
    required_project_items_statuses: Object,
    inventory_statuses: Object,
    units: Object,
    suppliers: Object,
    statuses: Object,
    categories: Object,
    producers: Object,
    warehouses: Object,
    order_where_list: Array,
    currencys: Object,
    kreator_kategorie: {
      type: Array,
      default: () => []
    },
    order_list: Object,
    negotiations: {
      type: Array,
      default: () => [],
    },
    openAddRequiredProjectItemsModal: {
      type: Boolean,
      default: false
    },

    liczba_maszyn: {
      type: Number,
      default: 1
    },

    now_restore_table: {
      type: Number,
      default: 1
    },
    table_settings: {
      type: Object,
      default: null
    }
  },

  beforeMount() {
    const toIntOr = (val, fallback = 0) => {
      const n = parseInt(val ?? '', 10);
      return Number.isFinite(n) ? n : fallback;
    };
    const toBool = (val, fallback = false) => {
      if (val === 'true') return true;
      if (val === 'false') return false;
      return fallback;
    };
    const orNull = (val) => {
      return (val && val !== 'null' && val !== 'undefined') ? val : null;
    };


    const url = new URL(window.location.href);
    const qId = url.searchParams.get('id');
    const qIds = url.searchParams.get('ids');

    const hasIdsParam =
      url.searchParams.has('id') ||
      url.searchParams.has('ids') ||
      url.searchParams.has('ids[]');
    if (hasIdsParam) {
      sessionStorage.removeItem('selectedProjectId');
      sessionStorage.removeItem('selectedTeam');
      sessionStorage.removeItem('archivedShown');

      this.selectedProjectId = 0;
      this.selectedTeamName = null;
      this.archivedShown = false;
    }

    const storedProjectIdRaw = sessionStorage.getItem('selectedProjectId');
    const storedTeamRaw = sessionStorage.getItem('selectedTeam');
    const archivedRaw = sessionStorage.getItem('archivedShown');

    this.selectedProjectId = toIntOr(storedProjectIdRaw, 0);
    this.selectedTeamName = orNull(storedTeamRaw);
    this.archivedShown = toBool(archivedRaw, false);

    if (this.selectedProjectId !== 0 && !this.projects?.some(p => Number(p.id) === this.selectedProjectId)) {
      this.selectedProjectId = 0;
    }
    if (this.selectedProjectId) this.updateTeams();

    const parseIds = (s) => (s || '')
      .split(',')
      .map(v => parseInt(String(v).trim(), 10))
      .filter(n => Number.isFinite(n) && n > 0);

    let ids = [...parseIds(qId), ...parseIds(qIds)];

    ids = Array.from(new Set(ids));

    if (ids.length === 1) {
      const idNum = ids[0];
      this.initialDeepLinkId = idNum;
      this.filterOptions.columns = [{ field: 'id', operator: 'equal', value: idNum }];
      this.gridQuery = new Query().where('id', 'equal', idNum);
    } else if (ids.length > 1) {
      this.initialDeepLinkId = null;

      let predicate = new Predicate('id', 'equal', ids[0]);
      for (let i = 1; i < ids.length; i++) {
        predicate = predicate.or('id', 'equal', ids[i]);
      }

      this.filterOptions.columns = ids.map(v => ({
        field: 'id',
        operator: 'equal',
        value: v
      }));

      this.gridQuery = new Query().where(predicate);
    }

    this.getRequiredProjectItemsForProject();
  },
  mounted() {
    this.restoreTableIfNeeded();
    this.getNBPExchangeRate();
    this.calculateGridHeight();
    window.addEventListener('resize', this.calculateGridHeight);

    if (
      this.openAddRequiredProjectItemsModal &&
      this.articlesToClone &&
      this.articlesToClone.length > 0
    ) {
      this.showAddRequiredProjectItemsModal = true;
      this.$nextTick(() => {
        this.$refs.addRequiredProjectItemsModalRef.show();
      });
    }

    const gridEl = document.getElementById('requiredProjectItemsGrid');

    if (gridEl) {
      gridEl.addEventListener('mousedown', (e) => {
        if (e.which === 3) {
          this.preventRightClickSelection = true;
        }
      });
    }

    const grid = this.$refs.requiredProjectItemsGrid.ej2Instances;
    grid.search("");
    this.hasSearch = false;
    const input = document.getElementById(grid.element.id + "_searchbar");

    if (input) {
      input.value = grid.searchSettings.key || "";
    }

  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calculateGridHeight)
  },

  data() {

    return {
      tableSettingsApplied: false,
      hasTableSettings: false,
      hasSearch: false,
      showEditModal: false,
      showAddRequiredProjectItemsModal: false,
      showOrderCreatorModal: false,
      showCreatorListModal: false,
      showAddToQuoteRequestModal: false,
      showAddOrderModal: false,
      showAddToOrderModal: false,
      showCloneRequestProjectItemModal: false,
      showReplacementArticleModal: false,
      showChangeStatusModal: false,
      showChangeStatusMagModal: false,
      showChangeDeliveryDateModal: false,
      showChangeReleaseDateModal: false,
      showChangeOrderSubmissionDateModal: false,
      showChangeOrderStatusConfirmationDateModal: false,
      showDispositionDWModall: false,
      showChangeMagazynModal: false,
      showDraftDispositionsModal: false,
      isFilterOpen: false,
      articlesToClone: null,
      goToPageNumber: 1,
      gridHeight: '64vh',
      hasPermission,
      hasRole,
      archivedShown: false,
      preventRightClickSelection: false,
      teams: [],
      requiredProjectItemsDataManager: [],
      fetchedOrders: [],
      selectedProjectId: 0,
      selectedTeamName: null,
      showFilesModal: false,
      showRequiredFilesModal: false,
      selectedArticle: null,
      addRequiredProjectItemsModalRef: ref(null),
      editArticleModalRef: ref(null),
      showEditArticleModal: false,
      selectedRecordToEdit: null,
      selectedRecords: null,
      selectedRecord: null,
      generatingPDF: false,
      pageSettings: { pageSize: 30, pageCount: 5, pageSizes: [10, 20, 30, 50, 100] },
      filterOptions: { type: "Menu", operator: 'contains' },
      filterDefault: { operator: 'contains', params: { minLength: 2 } },
      filterNumeric: { operator: 'equal' },
      editSettings: this.getEditSettings(),
      selectionOptions: { type: 'Multiple', persistSelection: true, checkboxOnly: true },
      contextMenuItems: this.getContextMenu(),
      gridQuery: new Query(),
      initialDeepLinkId: null,
      exchangeRates: {
        date: null,
        rates: {
          pln: 1,
          eur: 0,
          usd: 0
        }
      },
      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: { text: 'name', value: 'id' },
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterCategories: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.categories,
              fields: { text: 'name', value: 'id' },
              placeholder: 'Szukaj kategorii',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterProducers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.producers,
              fields: { text: 'name', value: 'id' },
              placeholder: 'Szukaj producentów',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterWarehouses: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.warehouses,
              fields: { text: 'short_name', value: 'id' },
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterSuppliers: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', { className: 'flm-input' });
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.suppliers,
              fields: { text: 'short_name', value: 'id' },
              placeholder: 'Szukaj dostawców',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },
      filterStatusMag: {
        ui: {
          create: (args) => {
            const input = createElement('input', { className: 'flm-input' });
            args.target.appendChild(input);

            this.statusFilter = new DropDownList({
              dataSource: [
                { name: 'Brak statusu', value: '__NULL__' },
                ...this.inventory_statuses.map(x => ({
                  name: x.name,
                  value: x.name
                }))
              ],
              fields: { text: 'name', value: 'value' },
              placeholder: 'Szukaj Statusu mag.',
              allowFiltering: true,
              popupHeight: '200px'
            });

            this.statusFilter.appendTo(input);
          },

          write: (args) => {
            this.statusFilter.value = args.filteredValue ?? null;
          },

          read: (args) => {
            const value = this.statusFilter.value;

            if (value === '__NULL__') {
              args.fltrObj.filterByColumn(
                args.column.field,
                'equal',
                '__NULL__'
              );
              return;
            }

            if (!value) {
              args.fltrObj.clearFiltering([args.column.field]);
              return;
            }

            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              value
            );
          }
        }
      },

      dateValue: null,
      rangeDateFilter: {
        ui: {
          create: (args) => {
            if (args.getOptrInstance && args.getOptrInstance.dropOptr) {
              let optrElement = args.getOptrInstance.dropOptr.element;
              if (optrElement && optrElement.parentElement) {
                optrElement.parentElement.parentElement.style.display = "none";
              }
            }

            let flValInput = createElement("input", { className: "flm-input" });
            args.target.appendChild(flValInput);

            this.dateRangePicker = new DateRangePicker({
              placeholder: "Wybierz zakres dat",
              change: (e) => {
                if (e && e.value) {
                  this.dateValue = e.value;
                  this.applyDateFilter(args.column.field);
                } else {
                  this.clearDateFilter(args.column.field);
                }
              }
            });
            this.dateRangePicker.appendTo(flValInput);
          },
          write: () => {
            if (this.dateValue) {
              this.dateRangePicker.value = this.dateValue;
            }
          },
          read: (args) => {
          }
        }
      },

      editNumbersPlusParams: {
        params: {
          min: 0,
          validateDecimalOnType: true
        }
      },

      wasEditedLaterEdit: {
        params: {
          dataSource: [
            { text: 'Tak', value: 1 },
            { text: 'Nie', value: 0 }
          ],
          query: new Query(),
          fields: { text: 'text', value: 'value' }
        }
      },

      suppliersParams: {
        create: () => {
          delivererElem = document.createElement('input');
          return delivererElem;
        },
        read: () => {
          return multiSelectObj.value.join(",");
        },
        destroy: () => {
          multiSelectObj.destroy();
        },
        write: (args) => {
          const selectedValues = args.rowData.suppliers_short_names ? args.rowData.suppliers_short_names.split(",") : [];

          multiSelectObj = new MultiSelect({
            value: selectedValues,
            dataSource: this.suppliers,
            fields: { text: "short_name", value: "short_name" },
            placeholder: 'Wybierz dostawców',
            mode: 'Box',
            allowFiltering: true,
            popupHeight: '200px',
            closePopupOnSelect: false
          });

          multiSelectObj.appendTo(delivererElem);
        }
      },

      requiredProjectItemsStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.required_project_items_statuses,
            fields: { value: 'name', text: 'name' },
            enabled: hasPermission('canChangeStatusRequiredProjectItems'),
            placeholder: 'Wybierz status',
            floatLabelType: 'Never'
          });

          statusObj.appendTo(statusElem);
        }
      },

      inventoryStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj?.text || '';
        },
        destroy: () => {
          statusObj?.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.inventory_statuses,
            fields: { text: 'name', value: 'name' },
            enabled: true,
            placeholder: 'Wybierz status mag',
            floatLabelType: 'Never'
          });

          statusObj.appendTo(statusElem);
        }
      }

    };
  },
  watch: {
    table_settings: {
      immediate: true,
      deep: true,
      handler(value) {
        this.hasTableSettings = !!(value?.settings);
      }
    }
  },
  computed: {
    toolbar() {
      return this.getToolbar();
    },

    liczba_maszyn() {
      const project = this.projects.find(
        p => p.id === Number(this.selectedProjectId)
      );

      if (!project) return 1;

      const team = project.teams.find(
        t => t.name === this.selectedTeamName
      );
      return team?.quantity ?? 1;
    }
  },
  methods: {
    truncateLabel(label) {
      if (!label) return '';
      return label.length > 40 ? label.substring(0, 40) + '...' : label;
    },

    updateSelectedProject() {
      // Twoja dotychczasowa logika
    },

    restoreTableIfNeeded() {
      if (this.now_restore_table !== 0) {
        return;
      }

      let grid = this.$refs.requiredProjectItemsGrid;

      if (!grid || !grid.$el || !grid.ej2Instances) {
        return;
      }

      let gridName = 'grid' + grid.$el.id;

      grid.ej2Instances.enablePersistence = false;

      window.localStorage.setItem(gridName, "");

      grid.ej2Instances.destroy();

      (function stripIdsFromUrl() {
        try {
          const url = new URL(window.location.href);

          url.searchParams.delete('ids');
          url.searchParams.delete('ids[]');

          history.replaceState(
            history.state,
            '',
            url.toString()
          );
        } catch (e) {
          const href = window.location.href;

          const cleaned = href
            .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
            .replace(/[?&]$/, '');

          history.replaceState(
            history.state,
            '',
            cleaned
          );
        }
      })();
      this.applyTableSettings();
      location.reload();
    },

    openOrderWizard() {
      if ((this.selectedProjectId && this.selectedProjectId !== '0') && (this.selectedTeamName && this.selectedTeamName !== 'null')) {
        this.showOrderCreatorModal = true;
        this.$nextTick(() => {
          this.$refs.OrderCreatorModalRef.show();
        });
      } else
        this.errorMsg('Najpierw wybierz projekt i zespół.');
    },

    openListWizard() {
      if ((this.selectedProjectId && this.selectedProjectId !== '0') && (this.selectedTeamName && this.selectedTeamName !== 'null')) {
        this.showCreatorListModal = true;
        this.$nextTick(() => {
          this.$refs.CreatorListModalRef.show();
        });
      } else
        this.errorMsg('Najpierw wybierz projekt i zespół.');
    },

    getRowIndex(data) {
      const grid = this.$refs.requiredProjectItemsGrid?.ej2Instances;
      const pageSize = grid?.pageSettings?.pageSize ?? 30;
      const currentPage = grid?.pageSettings?.currentPage ?? 1;
      const index = Number(data.index);
      return ((currentPage - 1) * pageSize) + (index % pageSize) + 1;
    },
    applyTableSettings() {
      const grid = this.$refs.requiredProjectItemsGrid?.ej2Instances;

      if (!grid || !this.table_settings?.settings) {
        return;
      }

      let settings;

      try {
        settings = JSON.parse(this.table_settings.settings);
      } catch (error) {
        console.error('Błąd odczytu ustawień tabeli:', error);
        return;
      }
      if (!Array.isArray(settings)) {
        return;
      }
      settings.forEach(setting => {
        if (!setting.field) {
          return;
        }
        const column = grid.columns.find(
          col => col.field === setting.field
        );
        if (!column) {
          return;
        }
        if (setting.width !== undefined) {
          column.width = setting.width;
        }
        column.visible = setting.visible !== false;
      });

      grid.refreshColumns();

      const savedFields = settings
        .filter(setting => setting.field)
        .sort((a, b) => a.index - b.index)
        .map(setting => setting.field);

      const currentFields = grid.columns
        .filter(column => column.field)
        .map(column => column.field);

      savedFields.forEach((field, targetIndex) => {
        const currentIndex = currentFields.indexOf(field);

        if (currentIndex === -1 || currentIndex === targetIndex) {
          return;
        }

        const targetField = currentFields[targetIndex];

        if (!targetField) {
          return;
        }

        grid.reorderColumns(
          field,
          targetField
        );

        // aktualizujemy tylko lokalną kolejność FIELD
        currentFields.splice(currentIndex, 1);
        currentFields.splice(targetIndex, 0, field);
      });

      grid.refreshColumns();
    },

    async getNBPExchangeRate() {

      this.loadingRate = true;
      try {
        const response = await axios.get(route('api.exchange-rates'));
        this.exchangeRates = response.data;
      } catch (e) {
        this.exchangeRates = {
          date: null,
          rates: {
            pln: 1,
            eur: 0,
            usd: 0
          }
        };
      }
      this.loadingRate = false;
    },

    valueNettoAccessor: function (field, data) {
      const quantity = Number(data.quantity_to_order || 0);
      const priceNetto = Number(data.article?.price_netto || 0);

      return quantity * priceNetto;
    },

    excelQueryCellInfo(args) {
      if (args.column.field === 'quote_request_numbers') {
        args.value = args.data.quote_request_items
          ?.map(x => x.quote_request_number)
          .join(', ') || '';
      }

      if (args.column.field === 'order_list_numbers') {
        args.value = args.data.order_lists
          ?.map(x => x.order_number)
          .join(', ') || '';
      }

      if (args.column.field === 'dw_numbers') {
        args.value = args.data.dw_warehouse_movements
          ?.map(x => `${x.document_number} - ${x.quantity} ${args.data.article?.article_unit?.name ?? ''}`)
          .join(', ') || '';
      }
    },

    dataBoundHandler() {
      if (!this.tableSettingsApplied) {
        this.tableSettingsApplied = true;
        this.applyTableSettings();
      }
      const grid = this.$refs.requiredProjectItemsGrid.ej2Instances;

      const hasSearchNow = !!grid.searchSettings.key;

      if (this.hasSearch !== hasSearchNow) {
        this.hasSearch = hasSearchNow;
        this.toolbar = this.getToolbar();
      }

      const selectAll = grid.element.querySelector('.e-checkselectall')?.closest('th');

      if (selectAll && !selectAll.dataset.customSelect) {
        selectAll.dataset.customSelect = "true";

        selectAll.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const records = grid.getCurrentViewRecords();
          const indexes = records.map((_, index) => index);
          const selectedIndexes = grid.getSelectedRowIndexes();
          const allSelected = indexes.every(index => selectedIndexes.includes(index));

          if (allSelected) {
            grid.clearSelection();
          } else {
            grid.selectRows(indexes);
          }

        }, true);
      }
    },

    clearSelection() {
      this.selectedRecords = [];
      this.selectedRecord = [];
      this.articlesToClone = [];
      this.selectedRecordToEdit = [];

      this.$nextTick(() => {
        const grid = this.$refs.requiredProjectItemsGrid?.ej2Instances;
        if (!grid) return;
        grid.clearSelection();
        grid.refresh();
      });
    },
    goToPage() {
      const grid = this.$refs.requiredProjectItemsGrid;

      if (this.goToPageNumber > 0) {
        grid.goToPage(this.goToPageNumber);
      }
    },
    isAdmin() {
      return hasRole('ADMIN');
    },

    calculateGridHeight() {
      const topOffset =
        document.getElementById('requiredProjectItemsGrid')
          ?.getBoundingClientRect().top || 200

      this.gridHeight = `${window.innerHeight - topOffset - 140}px`
    },

    rowSelecting(args) {
      if (this.preventRightClickSelection === true) {
        args.cancel = true;
        this.preventRightClickSelection = false;
      }
    },

    getEditSettings() {
      return {
        allowEditing: hasPermission('canEditRequiredProjectItems'),
        allowAdding: hasPermission('canEditRequiredProjectItems'),
        allowDeleting: hasPermission('canEditRequiredProjectItems'),
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top'
      };
    },

    getToolbar() {
      const tools = [];
      const hasSearch = this.$refs.requiredProjectItemsGrid?.ej2Instances?.searchSettings?.key?.length > 0;

      if (hasPermission('canEditRequiredProjectItems')) {
        tools.push("Add");
      }

      if (hasPermission('canDelRequiredProjectItems')) {
        tools.push({ text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn' });
      }
      if (hasPermission('canEditRequiredProjectItems')) {
        tools.push("Update");
        tools.push("Cancel");
      }

      tools.push(
        { text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters' });
      if (hasPermission('canEditRequiredProjectItems')) {
        tools.push({ text: "Dyspozycje robocze", prefixIcon: 'e-description', id: 'draft_dispositions' });
      }
      tools.push({ text: "Search", prefixIcon: 'e-search', id: "search", align: 'center' });

      if (this.hasSearch) {
        tools.push({
          text: "",
          prefixIcon: "e-close",
          id: "clear_search",
          align: 'center'
        });
      }
      tools.push({ text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
      if (this.hasTableSettings) {
        tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
      }

      tools.push({ text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
        { text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right' },
        "ColumnChooser"
      );
      return tools;
    },

    queryCellInfo(args) {
      if (args.column.field === 'delivery_date') {
        const diffDays = this.DeliveryDeadlineDates(args.data.delivery_date, args.data.inventory_status_name);

        if (diffDays > 0) {
          args.cell.style.backgroundColor = 'red';
          args.cell.style.color = 'white';
        }
      }

      if (args.column.field === "article.catalog_number" || args.column.field === "article.model") {
        if (args.data.article && args.data.article.deleted_at) {
          args.cell.setAttribute('title', 'Ten artykuł został usunięty!');
          args.cell.classList.add("deleted-article");
        }
      }

      const stackFields = new Set([
        'id',
        'article.id',
        'article.catalog_number',
        'article.model',
        'article.description',
        'article.link',
        'article.article_unit.name',
        'article.producer.id',
        'article.customer_category.id'
      ]);

      if (stackFields.has(args.column.field)) {
        args.cell.classList.add('stack-cell');
      }
    },

    headerCellInfoEvent: function (args) {
      new Tooltip(
        {
          content: args.cell.column.headerTooltip
        },
        args.node
      );

    },

    clickShowHistoryModal() {
      this.$refs.showHistoryModalRef.show();
    },

    clickToolbarHandler: async function (args) {

      if (args.item.text === 'Dodaj') {
        args.cancel = true;

        if ((this.selectedProjectId && this.selectedProjectId !== '0') && (this.selectedTeamName && this.selectedTeamName !== 'null')) {
          this.showAddRequiredProjectItemsModal = true;
          await this.$nextTick(() => {
            this.$refs.addRequiredProjectItemsModalRef.show();
          });
        } else
          this.errorMsg('Najpierw wybierz projekt i zespół.');
      }

      if (args.item.text === 'Usuń') {
        const selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        if (selectedRecords.length > 0) {
          selectedRecords.forEach((record) => {
            this.$refs.requiredProjectItemsGrid.deleteRecord("id", record);
          });
        }
      }

      if (args.item.id === 'reset_filters') {
        const gridRef = this.$refs.requiredProjectItemsGrid;

        const hadIds = (function stripIdsFromUrl() {
          try {
            const url = new URL(window.location.href);
            const had = url.searchParams.has('ids') || url.searchParams.has('ids[]');

            if (had) {
              url.searchParams.delete('ids');
              url.searchParams.delete('ids[]');
              history.replaceState(history.state, '', url.toString());
            }
            return had;
          } catch (e) {
            const href = window.location.href;
            const re = /([?&])ids(\[\])?=[^&#]*/g;
            const had = re.test(href);

            if (had) {
              const cleaned = href
                .replace(re, (match, sep) => sep)
                .replace(/[?&]$/, '');
              history.replaceState(history.state, '', cleaned);
            }
            return had;
          }
        })();

        gridRef.clearFiltering?.();
        const grid = this.$refs.requiredProjectItemsGrid.ej2Instances;

        grid.search("");

        this.hasSearch = false;
        this.toolbar = this.getToolbar();
        if (hadIds) {
          location.reload();
        } else {
          gridRef.ej2Instances?.refresh();
        }


      }

      if (args.item.id === "clear_search") {
        const grid = this.$refs.requiredProjectItemsGrid.ej2Instances;

        grid.search("");

        this.hasSearch = false;
        this.toolbar = this.getToolbar();
      }

      if (args.item.id === 'draft_dispositions') {
        this.showDraftDispositionsModal = true;
        this.$nextTick(() => {
          this.$refs.draftDispositionsModalRef.show();
        });
      }

      if (args.item.id === 'restore') {
        let grid = this.$refs.requiredProjectItemsGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();

        (function stripIdsFromUrl() {
          try {
            const url = new URL(window.location.href);
            url.searchParams.delete('ids');
            url.searchParams.delete('ids[]');
            history.replaceState(history.state, '', url.toString());
          } catch (e) {
            const href = window.location.href;
            const cleaned = href
              .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
              .replace(/[?&]$/, '');
            history.replaceState(history.state, '', cleaned);
          }
        })();
        this.applyTableSettings();
        location.reload();
      }

      if (args.item.id === 'save') {
        const grid = this.$refs.requiredProjectItemsGrid?.ej2Instances;

        if (!grid) {
          console.warn('Grid nie został znaleziony');
          this.errorMsg("Konfiguracja tabeli nie została zapisana!");
          return;
        }

        const tableId = 'requiredProjectItemsGrid';

        const settings = grid.columns.map((column, index) => ({
          field: column.field || null,
          index: index,
          width: column.width,
          visible: column.visible !== false
        }));

        try {
          const response = await axios.post('/table-settings', {
            tableId: tableId,
            columns: JSON.stringify(settings)
          });

          this.hasTableSettings = true;
          this.successMsg(
            "Konfiguracja tabeli została pomyślnie zapisana!"
          );

        } catch (error) {
          console.error(
            'Błąd zapisu ustawień:',
            error.response?.data || error
          );

          this.errorMsg(
            "Konfiguracja tabeli nie została zapisana!"
          );
        }
      }
      if (args.item.id === 'delete-set') {
        const tableId = 'requiredProjectItemsGrid';
        try {
          const response = await axios.delete('/table-settings-delete', {
            data: {
              tableId: tableId
            }
          }
          );
          this.hasTableSettings = false;
          this.successMsg(
            "Konfiguracja tabeli została pomyślnie usunięta!"
          );
        } catch (error) {
          this.errorMsg(
            "Konfiguracja tabeli nie została usunięta!"
          );
        }
      }
      if (args.item.id === 'excelexport') {

        const grid = this.$refs.requiredProjectItemsGrid;

        const hiddenColumns = [
          'was_edited_later',
          'files',
          'article.files'
        ];

        hiddenColumns.forEach(field => {
          const col = grid.getColumnByField(field);
          if (col) {
            col.visible = false;
          }
        });

        grid.refreshColumns();

        grid.excelExport({
          fileName: 'Zapotrzebowania projektowe.xlsx'
        }).then(() => {

          hiddenColumns.forEach(field => {
            const col = grid.getColumnByField(field);
            if (col) {
              col.visible = true;
            }
          });

          grid.refreshColumns();
        });
      }
    },

    getContextMenu() {
      const contextMenu = [];

      if (hasPermission('canEditArticles')) {
        contextMenu.push(
          { text: 'Edytuj artykuł', target: '.e-content', id: 'edit_article' }
        );
      }

      if (hasPermission('canEditRequiredProjectItems')) {
        contextMenu.push(
          { separator: true },
          { text: 'Klonuj wiersz', target: '.e-content', id: 'clone_selected' },
          { text: 'Kopiuj do innego projektu/zespołu', target: '.e-content', id: 'clone_to_other_project' },
          { separator: true },
          { text: 'Akceptuj zamiennik', target: '.e-content', id: 'accept_replacement' },
          { text: 'Odrzuć zamiennik', target: '.e-content', id: 'reject_replacement' },
          { text: 'Zaproponuj zamiennik', target: '.e-content', id: 'replacement_article' },
          { separator: true }
        );
      }

      if (hasPermission('canEditQuoteRequests')) {
        contextMenu.push(
          { text: 'Utwórz zapytanie ofertowe', target: '.e-content', id: 'create_quote_request' },
        );
      }

      if (hasPermission('canEditOrders')) {
        contextMenu.push(
          { text: 'Utwórz zamówienie', target: '.e-content', id: 'create_order' },
          { text: 'Dodaj do zamówienia', target: '.e-content', id: 'add_to_order' },
        );
      }

      if (hasPermission('canEditQuoteRequests') || hasPermission('canEditOrders')) {
        contextMenu.push(
          { separator: true },
        );
      }

      if (hasPermission('canChangeStatusRequiredProjectItems')) {
        contextMenu.push(
          { text: 'Zmień status', target: '.e-content', id: 'change_status' }
        );
      }
      if (hasPermission('canChangeStatusRequiredProjectItemsOnly')) {
        contextMenu.push(
          { text: 'Zmień status magazynowy', target: '.e-content', id: 'change_status_mag' }

        );
      }
      if (hasPermission('canWarehouseDispositions')) {
        contextMenu.push(
          { text: 'Zmień magazyn', target: '.e-content', id: 'change_magazyn' },
          { text: 'Zmień datę dostawy', target: '.e-content', id: 'change_delivery_date' },
          { text: 'Zmień datę zwolnienia', target: '.e-content', id: 'change_release_date' },
          { text: 'Zmień datę zlecenia zamówienia', target: '.e-content', id: 'change_order_submission_date' },
          { text: 'Dyspozycja magazynowa DW', target: '.e-content', id: 'disposition_dw' }
        );
      }

      return contextMenu;
    },

    onContextMenuOpen(args) {
      const selected = this.$refs.requiredProjectItemsGrid?.getSelectedRecords() || [];
      if (!selected.length) {
        args.cancel = true;
        return;
      }

      const row = args?.rowInfo?.rowData;
      const hasRepl = !!(row && row.replacement && row.replacement.article);

      const menu = this.$refs.requiredProjectItemsGrid
        .ej2Instances.contextMenuModule.contextMenu;

      menu.showItems(['accept_replacement', 'reject_replacement', 'replacement_article'], true);

      if (hasRepl) {
        menu.showItems(['accept_replacement', 'reject_replacement'], true);
        menu.hideItems(['replacement_article'], true);
      } else {
        menu.hideItems(['accept_replacement', 'reject_replacement'], true);
        menu.showItems(['replacement_article'], true);
      }
    },

    clickContextMenuHandler(args) {
      const selectedRecords = this.$refs.requiredProjectItemsGrid?.getSelectedRecords() || [];

      if (
        ['create_quote_request', 'create_order', 'add_to_order'].includes(args.item.id) &&
        selectedRecords.some(record => record.status === 'NIE')
      ) {
        this.errorMsg("Nie można wykonać operacji, w zaznaczonych rekordach znajdują się nie zwolnione pozycje!");
        return;
      }

      if (args.item.id === 'edit_article') {
        this.selectedRecordToEdit = args.rowInfo.rowData.article;
        this.showEditModal = true;
        this.$nextTick(() => {
          this.$refs.editArticleModalRef.show();
        });
      }

      if (args.item.id === 'create_quote_request') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showAddToQuoteRequestModal = true;
        this.$nextTick(() => {
          this.$refs.addQuoteRequestModalRef.show();
        });
      }

      if (args.item.id === 'create_order') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showAddOrderModal = true;
        this.$nextTick(() => {
          this.$refs.addOrderModalRef.show();
        });
      }

      if (args.item.id === 'add_to_order') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showAddToOrderModal = true;
        this.$nextTick(() => {
          this.$refs.addToOrderModalRef.show();
        });
      }

      if (args.item.id === 'clone_selected') {
        this.articlesToClone = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showAddRequiredProjectItemsModal = true;
        this.$nextTick(() => {
          this.$refs.addRequiredProjectItemsModalRef.show();
        });
      }

      if (args.item.id === 'clone_to_other_project') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showCloneRequestProjectItemModal = true;
        this.$nextTick(() => {
          this.$refs.cloneRequestProjectItemModalRef.show();
        });
      }

      if (args.item.id === 'replacement_article') {
        this.selectedRecord = args.rowInfo?.rowData;
        this.showReplacementArticleModal = true;
        this.$nextTick(() => {
          this.$refs.replacementArticleModalRef.show();
        });
      }

      if (args.item.id === 'accept_replacement') {
        const row = args.rowInfo?.rowData;
        const rpi = row?.id;
        const ra = row?.replacement?.id;

        if (!rpi || !ra) return;

        Toast.fire({
          toast: false, icon: 'question', title: 'Zaakceptuj zamiennik',
          html: 'Jesteś pewny, że chcesz zaakceptować ten zamiennik?',
          showDenyButton: true, position: 'center', timer: false,
          showConfirmButton: true, confirmButtonText: 'Tak', denyButtonText: 'Nie'
        }).then(async (res) => {
          if (!res.isConfirmed) return;
          try {
            const { data } = await axios.post(
              route('requiredProjectItems.replacement.signed-url'),
              { action: 'accept', rpi, ra }
            );
            this.$inertia.get(data.url);
          } catch (e) {
            this.errorMsg(e?.response?.data?.message || 'Nie udało się wygenerować linku.');
          }
        });
      }

      if (args.item.id === 'reject_replacement') {
        const row = args.rowInfo?.rowData;
        const rpi = row?.id;
        const ra = row?.replacement?.id;
        if (!rpi || !ra) return;

        Toast.fire({
          toast: false, icon: 'question', title: 'Odrzuć zamiennik',
          html: 'Jesteś pewny, że chcesz odrzucić ten zamiennik?',
          showDenyButton: true, position: 'center', timer: false,
          showConfirmButton: true, confirmButtonText: 'Tak', denyButtonText: 'Nie'
        }).then(async (res) => {
          if (!res.isConfirmed) return;
          try {
            const { data } = await axios.post(
              route('requiredProjectItems.replacement.signed-url'),
              { action: 'reject', rpi, ra }
            );
            this.$inertia.get(data.url);
          } catch (e) {
            this.errorMsg(e?.response?.data?.message || 'Nie udało się wygenerować linku.');
          }
        });
      }

      if (args.item.id === 'change_status') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showChangeStatusModal = true;
        this.$nextTick(() => {
          this.$refs.changeStatusModalRef.show();
        });
      }

      if (args.item.id === 'change_status_mag') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showChangeStatusMagModal = true;
        this.$nextTick(() => {
          this.$refs.changeStatusMagModalRef.show();
        });
      }

      if (args.item.id === 'change_magazyn') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showChangeMagazynModal = true;
        this.$nextTick(() => {
          this.$refs.changeMagazynModalRef.show();
        });
      }

      if (args.item.id === 'change_delivery_date') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showChangeDeliveryDateModal = true;
        this.$nextTick(() => {
          this.$refs.changeDeliveryDateModalRef.show();
        });
      }

      if (args.item.id === 'change_release_date') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showChangeReleaseDateModal = true;
        this.$nextTick(() => {
          this.$refs.changeReleaseDateModalRef.show();
        });
      }

      if (args.item.id === 'change_order_submission_date') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showChangeOrderSubmissionDateModal = true;
        this.$nextTick(() => {
          this.$refs.changeOrderSubmissionDateModalRef.show();
        });
      }

      if (args.item.id === 'disposition_dw') {
        this.selectedRecords = this.$refs.requiredProjectItemsGrid.getSelectedRecords();
        this.showDispositionDWModall = true;
        this.$nextTick(() => {
          this.$refs.dispositionDWModalRef.show();
        });
      }
    },


    updateSelectedProject(event) {
      this.selectedProjectId = Number(event.target.value);
      this.teams = null;
      this.selectedTeamName = null;
      if (this.selectedProjectId) {
        this.updateTeams();
      }

      this.getRequiredProjectItemsForProject();
    },

    updateTeams() {
      if (this.selectedProjectId) {
        const project = this.projects.find(project => project.id === Number(this.selectedProjectId));
        if (project) {
          this.teams = project.teams;
        }
      } else {
        this.teams = [];
        this.selectedTeamName = null;
      }
    },

    updateSelectedTeam(event) {
      this.selectedTeamName = event.target.value;
      this.getRequiredProjectItemsForProject();
    },

    getRequiredProjectItemsForProject() {
      sessionStorage.setItem('selectedProjectId', this.selectedProjectId);
      sessionStorage.setItem('selectedTeam', this.selectedTeamName);
      sessionStorage.setItem('archivedShown', this.archivedShown);
      document.cookie = `archivedShown=${this.archivedShown || false}; path=/;`;

      this.requiredProjectItemsDataManager = new DataManager({
        url: route('requiredProjectItems.getList', {
          project: this.selectedProjectId,
          team: this.selectedTeamName
        }),
        adaptor: new WebMethodAdaptor(),
        batchUrl: route('requiredProjectItems.saveChanges'),
        updateUrl: route('requiredProjectItems.updateChanges'),
        crossDomain: true,
        headers: [
          { 'X-CSRF-TOKEN': usePage().props.csrf_token },
          { 'archivedShown': sessionStorage.getItem('archivedShown') || false }
        ]
      });


      this.$nextTick(() => {
        const grid = this.$refs.requiredProjectItemsGrid?.ej2Instances;

        if (grid) {
          grid.dataSource = this.requiredProjectItemsDataManager;
          grid.refresh();
        }
      });

    },

    changeShowArchived() {
      sessionStorage.setItem('archivedShown', this.archivedShown || false);
      document.cookie = `archivedShown=${this.archivedShown || false}; path=/;`;
      if (this.$refs.requiredProjectItemsGrid) {
        const query = new Query().addParams('archivedShown', this.archivedShown);
        document.getElementById('requiredProjectItemsGrid').ej2_instances[0].query = query;
      }
    },

    dateFormatter(field, data) {
      const date = data.created_at ? data.created_at : null;
      if (date) {
        try {
          return moment(date).format('DD.MM.YYYY HH:mm:ss');
        } catch (error) {
          return data;
        }
      }

      return '';
    },

    onRecordClick(args) {
      this.selectedRecord = args.rowData;
      this.clearRowSelection();
      args.row.classList.add("selected-row");
    },

    clearRowSelection() {
      const rows = document.querySelectorAll(".selected-row");
      rows.forEach(row => row.classList.remove("selected-row"));
    },

    onCellEdit(args) {
      const isAdmin = usePage().props.user.roles.includes('ADMIN');

      if (!isAdmin) {
        if (args.rowData.inventory_status && (args.rowData.inventory_status !== null || args.rowData.inventory_status !== '')) {
          args.cancel = true;
          this.errorMsg('Nie można edytować, ponieważ status magazynowy na to nie pozwala.');
        }
      }
    },

    hasReplacement(row) {
      return !!(row && row.replacement && row.replacement.article);
    },
    resolveProducerName(id) {
      if (!id) return '';
      const p = this.producers?.find(x => String(x.id) === String(id));
      return p?.name ?? '';
    },
    resolveCategoryName(id) {
      if (!id) return '';
      const c = this.categories?.find(x => String(x.id) === String(id));
      return c?.name ?? id;
    },

    onKeyDown(args) {
      const grid = this.$refs.requiredProjectItemsGrid?.ej2Instances;
      if (!grid) return;

      const e = args.event || args;
      const code = e?.keyCode ?? args.which ?? args.keyCode;
      const key = e?.key || '';

      if ((e.ctrlKey || e.metaKey) && (code === 83 || key === 's' || key === 'S')) {
        e.preventDefault?.();
        const toolbar = document.getElementsByClassName('e-toolbar-left')[0];
        const buttons = toolbar?.querySelectorAll('.e-toolbar-item');
        const updateButton = buttons?.[2]?.querySelector('button');
        updateButton?.click();
        return;
      }

      const isArrowUp = code === 38 || key === 'ArrowUp';
      const isArrowDown = code === 40 || key === 'ArrowDown';
      if (!isArrowUp && !isArrowDown) return;

      e.preventDefault?.();
      e.stopPropagation?.();
      args.cancel = true;

      const data = grid.getCurrentViewRecords?.() || grid.currentViewData || [];
      if (!data.length) return;

      const contentEl = grid.getContent?.() || grid.element;
      const rows = Array.from(contentEl.querySelectorAll('tr.e-row'));
      const highlighted = contentEl.querySelector('tr.selected-row');

      let currentIdx = highlighted ? rows.indexOf(highlighted) : 0;
      if (currentIdx < 0) currentIdx = 0;

      const nextIdx = isArrowDown
        ? Math.min(currentIdx + 1, data.length - 1)
        : Math.max(currentIdx - 1, 0);

      if (nextIdx === currentIdx) return;

      const rowEl = (typeof grid.getRowByIndex === 'function')
        ? grid.getRowByIndex(nextIdx)
        : rows[nextIdx];

      this.selectedRecord = data[nextIdx];
      this.clearRowSelection?.();
      rowEl?.classList.add('selected-row');
      rowEl?.scrollIntoView({ block: 'nearest' });
    },

    actionBeginHandler(args) {

      const grid = this.$refs.requiredProjectItemsGrid?.ej2Instances;

      // Po zastosowaniu / zmianie filtra zawsze wracamy na stronę 1
      if (
        grid &&
        (
          args.requestType === 'filtering' ||
          args.requestType === 'filterAfterOpen'
        )
      ) {
        grid.goToPage(1);
      }

      if (args.requestType === 'filterBeforeOpen') {

        if (args.columnName === 'status') {

          args.filterModel.filterSettings.operators = {
            stringOperator: [
              { value: 'contains', text: 'Zawiera' },
              { value: 'doesnotcontain', text: 'Nie zawiera' }
            ]
          };
        }
      }

      if (args.requestType === 'searching') {
        const grid = this.$refs.requiredProjectItemsGrid.ej2Instances;
        const searchString = args.searchString?.trim() ?? '';
        grid.goToPage(1);

        this.values = searchString;

        const excludedFields = new Set([
          'created_at',
          'delivery_date',
          'release_date',
          'order_submission_date',
          'order_status_confirmation_date',
          'numbering.production_date',
          'updated_at',
          'deliveryDeadlineExceeded',
          'numbering.quantity',
          'lead_time',
          'files',
          'article.files',
          'article.currency.name',
          'currency.name',
          'was_edited_later',
          'article.link',
          'article.article_unit.name',
          'article.customer_category.id',
          'quantity_required',
          'article_main_warehouse.quantity',
          'article_project_warehouse_quantity',
          'quantity_to_order',
          'patent_number',
          'barcode'
        ]);

        if (!searchString) {
          grid.goToPage(1);
          grid.setProperties({
            query: new Query()
          }, true);

          return;
        }

        const keys = searchString
          .split(';')
          .map(key => key.trim())
          .filter(Boolean);

        const columns = grid.getColumns().filter(col =>
          col.field &&
          col.allowSearching !== false &&
          !excludedFields.has(col.field)
        );

        const predicates = [];

        keys.forEach(key => {
          const lowerKey = key.toLowerCase();

          columns.forEach(col => {
            const field = col.field;

            if (field === 'article.producer.id') {
              const matches = this.producers.filter(
                p => p.name?.toLowerCase().includes(lowerKey)
              );

              matches.forEach(p => {
                predicates.push(
                  new Predicate(
                    field,
                    'equal',
                    p.id,
                    true
                  )
                );
              });

              return;
            }

            predicates.push(
              new Predicate(
                field,
                'contains',
                key,
                true
              )
            );
          });
        });

        if (predicates.length) {
          let predicate = predicates[0];

          for (let i = 1; i < predicates.length; i++) {
            predicate = predicate.or(predicates[i]);
          }

          grid.setProperties({
            query: new Query().where(predicate)
          }, true);
        }

        return;
      }
    },

    actionCompleteHandler(args) {
      if (args.requestType === "refresh") {
        const searchBar = document.getElementById(
          this.$refs.requiredProjectItemsGrid.ej2Instances.element.id + "_searchbar"
        );

        if (this.valueAssign) {
          searchBar.value = this.values;
          this.valueAssign = false;
        }

        if (searchBar.value.trim() === "" && this.removeQuery) {
          this.$refs.requiredProjectItemsGrid.ej2Instances.query = new Query();
          this.removeQuery = false;
          this.$refs.requiredProjectItemsGrid.ej2Instances.refresh();
        }
      }

      if (args.requestType === "batchsave") {
        if (args.changes && args.changes.changedRecords) {
          this.successMsg("Dane zostały pomyślnie zapisane!");

        } else if (args.error) {
          this.errorMsg("Wystąpił błąd podczas zapisu danych: " + args.error);
        }
      }
      if (args.requestType === "searching") {
        this.hasSearch = !!args.searchString;
        this.toolbar = this.getToolbar();
      }
    },

    async showDWPDF(movementId, project_name, team_name) {

      this.generatingPDF = true;
      const projectName = project_name ? project_name : '';
      const teamName = team_name ? team_name : '';;

      try {
        const response = await axios.post(route('warehouse-movements.previewPdfByMovementId'), {
          document_type: 'dw',
          movement_id: movementId,
          teamName: teamName,
          projectName: projectName,

        }, {
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
      } catch (error) {
        console.error('Error generating PDF preview:', error);
        Toast.fire({
          icon: 'warning',
          title: 'Coś poszło nie tak',
          html: error.message ?? error,
          timer: 3500,
          timerProgressBar: true
        });
      } finally {
        this.generatingPDF = false;
      }
    },

    compareDeliveryDeadlineDates(productionDate, deliveryDate) {
      if (!productionDate || !deliveryDate) {
        return null;
      }

      const prodDate = new Date(productionDate);
      const delivDate = new Date(deliveryDate);

      const diffTime = prodDate - delivDate;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays < 0 ? Math.abs(diffDays) : 0;
    },
    DeliveryDeadlineDates(deliveryDate, inventory_status_name) {
      if (!deliveryDate) {
        return null;
      }

      if (inventory_status_name?.trim() === "Zrealizowane" || inventory_status_name?.trim() === "Anulowane") {
        return null;
      }

      const deliverDate = new Date(deliveryDate);
      const today = new Date();

      today.setHours(0, 0, 0, 0);
      deliverDate.setHours(0, 0, 0, 0);

      const diffTime2 = today - deliverDate;
      const diffDays2 = Math.ceil(diffTime2 / (1000 * 60 * 60 * 24));

      return diffDays2 > 0 ? diffDays2 : 0;
    },



    applyDateFilter(field) {
      if (!this.$refs.requiredProjectItemsGrid) return;

      let gridInstance = this.$refs.requiredProjectItemsGrid.ej2Instances;

      let startDate = this.dateValue ? new Date(this.dateValue[0]).toISOString().split("T")[0] : null;
      let endDate = this.dateValue ? new Date(this.dateValue[1]) : null;

      if (endDate) {
        endDate.setHours(23, 59, 59, 999);
        endDate = endDate.toISOString().split("T")[0];
      }

      let filters = [];

      if (startDate) {
        filters.push({
          field: field,
          operator: "greaterthanorequal",
          value: startDate,
          predicate: "and"
        });
      }

      if (endDate) {
        filters.push({
          field: field,
          operator: "lessthanorequal",
          value: endDate,
          predicate: "and"
        });
      }

      gridInstance.filterSettings.columns = filters;
      gridInstance.refresh();
    },

    clearDateFilter(field) {
      if (!this.$refs.grid) return;
      let gridInstance = this.$refs.requiredProjectItemsGrid;

      gridInstance.clearFiltering([field]);
      this.dateValue = null;
    },

    showAttachmentsModal(article) {
      this.selectedArticle = article;
      this.showFilesModal = true;
    },

    showRequiredAttachmentsModal(article) {
      this.selectedArticle = article;
      this.showRequiredFilesModal = true;
    },

    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

  }
};
</script>

<style scoped>
.not-editable {
  color: orangered;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style>
.selected-row {
  background-color: #f3f3f3 !important;
}

.e-grid .e-rowcell.stack-cell {
  position: relative;
  padding-bottom: 22px;
}

.e-grid .e-rowcell .cell-main {
  display: block;
  line-height: 1.25;
  word-break: break-word;
}

.e-grid .e-rowcell .cell-replacement {
  background: #fff7ed;
  color: #9a3412;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  width: 100%;
}

.status-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
}

.status-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.mobile-filter-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 340px;
  height: 100vh;
  background: white;
  z-index: 1060;
  transform: translateX(-100%);
  transition: transform 0.25s ease;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  padding: 16px;
}

.mobile-filter-panel.show {
  transform: translateX(0);
}
.offcanvas-mobile {
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 100vh;
  background: #fff;
  z-index: 1050;
  transform: translateX(-100%);
  transition: transform 0.25s ease;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.offcanvas-mobile.show {
  transform: translateX(0);
}

</style>
